import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { faUniversity } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faDragon } from "@fortawesome/free-solid-svg-icons";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-solid-svg-icons";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import router from "../router/router_clerks.js";
import router_user from "../router/router_user.js";
import store from "../store/store.js";
import Vue from "vue/dist/vue.esm";
import VueRouter from "vue-router";

import ClientApplication from "../client_application.vue";
import ClerkApplication from "../clerk_application.vue";
import BootstrapVue from "bootstrap-vue";

library.add(faUserSecret);
library.add(faUniversity);
library.add(faEdit);
library.add(faSave);
library.add(faTrash);
library.add(faFileExcel);
library.add(faTimes);
library.add(faCog);
library.add(faCalculator);
library.add(faExclamationCircle);
library.add(faInfoCircle);
library.add(faCheckCircle);
library.add(faUsers);
library.add(faInfoCircle);
library.add(faCheckCircle);
library.add(faDragon);
library.add(faBoxOpen);
library.add(faPencilAlt);
library.add(faAngleUp);
library.add(faAngleDown);
library.add(faSquare);
library.add(faCheckSquare);
library.add(faFileAlt);
library.add(faPlusCircle);
library.add(faExclamationTriangle);
library.add(faEye);

import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueRouter);
Vue.use(BootstrapVue);

window.addEventListener("load", function () {
    if (this.document.querySelector("#client-application")) {
        new Vue({
            el: "#client-application",
            components: { "client-application": ClientApplication },
            router: router_user,
            store: store,
        });
    }
    if (this.document.querySelector("#clerk-application")) {
        new Vue({
            el: "#clerk-application",
            components: { "clerk-application": ClerkApplication },
            router: router,
        });
    }
});
